import { render } from "./EntryCountdown.vue?vue&type=template&id=531e53c9&scoped=true"
import script from "./EntryCountdown.vue?vue&type=script&lang=js"
export * from "./EntryCountdown.vue?vue&type=script&lang=js"

import "./EntryCountdown.vue?vue&type=style&index=0&id=531e53c9&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531e53c9"]])

export default __exports__